import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from "react-router";
import { Route } from 'react-router-dom';
import { withTranslation } from 'react-i18next';
import i18n from 'cityads-v3/i18n';

import Card from 'cityads-v3/components/Card/Card';
import PopupArticle from 'cityads-v3/components/PopupArticle/PopupArticle';

import { getArticleClass, hasMore } from './utils';

@withRouter
@withTranslation(['main'], { i18n, wait: !!window })
export default class CardWithPopup extends Component {
  static propTypes = {
    history        : PropTypes.object.isRequired,
    moreLink       : PropTypes.string,
    lessLink       : PropTypes.string,
    moreButtonTitle: PropTypes.string,
    moreTitle      : PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    moreText       : PropTypes.node,
    moreElem       : PropTypes.element,
    articleClass   : PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    hidePopup      : PropTypes.oneOfType([PropTypes.bool, PropTypes.func]),
    t              : PropTypes.func,
  }

  handleClose = (evt) => {
    evt.stopPropagation();
    const { history, lessLink } =  this.props;
    if (lessLink) {
      history.push(lessLink);
    }
  };

  handleOpen = (evt) => {
    const { history, moreLink } = this.props;

    if (moreLink) {
      history.push(moreLink);
    }

    return true;
  }

  render() {
    const {
      actions,
      subActions,
      moreLink,
      morePath,
      moreButtonTitle,
      moreTitle,
      moreText,
      moreElem,
      articleClass: articleClassName,
      lessLink,
      children,
      hidePopup,
      ...otherProps
    } = this.props;

    const isMini = otherProps.isMini;

    const articleClass = getArticleClass(articleClassName);

    const cardHasMore = hasMore(this.props);

    const moreAction = (moreButtonTitle && cardHasMore) ?
      (isMini ?
        {
          tooltip  : moreButtonTitle,
          placement: 'top',
          link     : moreLink,
          icon     : 'arrow_forward',
          color    : 'primary',
          onClick  : this.handleOpen,
        } :
        {
          title  : moreButtonTitle,
          link   : moreLink,
          onClick: this.handleOpen,
        }
      ) :
      null;

    const actualMoreElem = articleClass ? React.createElement(articleClass) : moreElem;

    const newActions = [
      ...((moreAction && !isMini) ? [moreAction] : []),
      ...(actions || []),
    ];
    const newSubActions = [
      ...((moreAction && isMini) ? [moreAction] : []),
      ...(subActions || []),
    ];

    const showPopup = (typeof hidePopup === 'function') ? !hidePopup() : !hidePopup;

    return (
      <Card {...otherProps} actions={newActions} subActions={newSubActions}>
        {
          cardHasMore ?
            (
              <div>
                {children}
                <Route path={morePath || moreLink} children={({ match }) => (
                  <PopupArticle
                    title          = {moreTitle}
                    open           = {showPopup && Boolean(match)}
                    onRequestClose = {(evt) => this.handleClose(evt)}
                    closeLink      = {lessLink}
                    article        = {actualMoreElem}
                  >
                    {moreText}
                  </PopupArticle>
                )} />
              </div>
            ) :
            children
        }
      </Card>
    )
  }
}
